(async () => {
  'use strict';
  const catalogNode = document.getElementById('ry-bike-catalog');
  const copyNode = document.getElementById('ry-shopping-copy');
  if (!catalogNode || !copyNode) return;
  let source, copy;
  try { source = JSON.parse(catalogNode.textContent); copy = JSON.parse(copyNode.textContent); } catch { return; }
  const catalogCacheKey = 'ryvox:fitment-catalog:v5';
  let catalogIsFresh = false;
  try {
    const cached = JSON.parse(sessionStorage.getItem(catalogCacheKey));
    if (cached?.models?.length && Date.now() - cached.time < 900000) {
      source.models = cached.models; catalogIsFresh = true;
    }
  } catch {}
  const param = source.param;
  // Sean, 3 Nov 2026: a chosen bike shows every part listed for it and every part listed as Universal
  // (grips, tools, fluids). Values are ORed by Shopify within one filter.
  const UNIVERSAL = 'Universal';
  const partsPath = source.partsUrl || '/collections/performance-parts';
  const brands = ['Arctic Leopard', 'Electric Motion', 'E-Ride Pro', 'Stark Varg', 'Sur-Ron', '79Bike', 'Talaria', 'Ventus', 'RERODE', 'Rawrr', 'Altis', 'Bonnell', 'Zero', 'Yozma', 'Beta', 'Apollo', 'Surge'];
  // Sean, 3 Nov 2026 (later): the finder is brand + model only. A model's year listings are one choice
  // ("Sur-Ron Ultra Bee" also covers "Sur-Ron Ultra Bee (2025–2026)"; "Stark Varg (2023–2024)" counts for the
  // Varg EX and MX). The one year split customers still choose is the Light Bee X: 2026 vs earlier LBX.
  const KEEP_YEAR_SPLIT = ['Sur-Ron Light Bee X'];
  const baseOf = label => label.replace(/\s*\([^()]*\)\s*$/, '');
  const keepsYears = label => baseOf(label) === label || KEEP_YEAR_SPLIT.includes(baseOf(label));
  function buildModels(list) {
    const labels = [...new Set((list || []).map(m => m && m.label).filter(label => label && label !== UNIVERSAL))];
    const groups = new Map();
    const group = key => {
      if (!groups.has(key)) groups.set(key, { label: key, brand: brands.find(b => key.startsWith(b + ' ')) || key, values: [], pending: false });
      return groups.get(key);
    };
    labels.filter(keepsYears).forEach(label => group(label).values.push(label));
    labels.filter(label => !keepsYears(label)).forEach(label => {
      const base = baseOf(label);
      const exact = groups.get(base);
      const variants = exact ? [exact] : [...groups.values()].filter(g => g.label.startsWith(base + ' ') && !KEEP_YEAR_SPLIT.includes(baseOf(g.label)));
      (variants.length ? variants : [group(base)]).forEach(g => g.values.push(label));
    });
    (source.newModels || []).forEach(label => {
      if ([...groups.values()].some(g => g.label === label || g.values.includes(label))) return;
      const key = keepsYears(label) ? label : baseOf(label);
      if (!groups.has(key)) group(key).pending = true;
    });
    return [...groups.values()];
  }
  function groupModels(list) {
    return [...new Set(list.map(m => m.brand))].sort().map(label => ({label, models:list.filter(m => m.brand === label).sort((a,b) => a.label.localeCompare(b.label))}));
  }
  let models = buildModels(source.models);
  let catalog = groupModels(models);
  const storageKey = 'ryvox:selected-bike:v2';
  const dialog = document.getElementById('ry-bike-dialog');
  const params = new URLSearchParams(location.search);
  let selected = null;
  function findBike(label) {
    const exact = models.find(m => m.label === label);
    if (exact) return exact;
    const holders = models.filter(m => (m.values || []).includes(label));
    return holders.length === 1 ? holders[0] : null;
  }
  const isSelectedValue = label => !!selected && (label === selected.label || (selected.values || []).includes(label));
  function scopeLabels(label) {
    const bike = findBike(label);
    const values = bike && bike.values && bike.values.length ? bike.values : [label];
    return [...new Set([...values, UNIVERSAL])];
  }
  function setScope(searchParams, label) {
    searchParams.delete(param);
    scopeLabels(label).forEach(value => searchParams.append(param, value));
  }
  try { const saved = JSON.parse(localStorage.getItem(storageKey)); selected = saved && findBike(saved.label); } catch {}
  const urlBike = params.get(param);
  if (urlBike) selected = findBike(urlBike) || { label: urlBike, brand: urlBike.split(' ')[0], pending: false, values: [urlBike] };
  document.querySelectorAll('[data-ry-fit-start]').forEach(node => { node.hidden = !!selected; });
  if (selected) { try { localStorage.setItem(storageKey, JSON.stringify({label:selected.label})); } catch {} }
  const isSearch = location.pathname.endsWith('/search');
  const initialScope = params.get('ry_scope') || (urlBike ? 'bike' : selected ? 'bike' : 'all');
  if (isSearch && selected && initialScope === 'bike' && !urlBike) {
    const scoped = new URL(location.href); setScope(scoped.searchParams, selected.label); scoped.searchParams.set('ry_scope','bike'); scoped.searchParams.delete('page'); location.replace(scoped.pathname + scoped.search); return;
  }
  function modelUrl(bike, base = partsPath) {
    const url = new URL(base, location.origin);
    setScope(url.searchParams, bike.label);
    return url.pathname + url.search;
  }
  function track(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
    if (document.querySelector('script[data-ry-shopping][data-live-theme="true"]') === null) return;
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.gtag === 'function') window.gtag('event', name, detail);
  }
  const forms = [...document.querySelectorAll('[data-ry-finder]')];
  forms.forEach(form => {
    const brand = form.querySelector('[data-ry-brand]');
    const model = form.querySelector('[data-ry-model]');
    const go = form.querySelector('[data-ry-go]');
    brand.replaceChildren(new Option(copy.chooseBrand, ''));
    catalog.forEach(b => brand.add(new Option(b.label, b.label)));
    if (selected) brand.value = selected.brand;
    function populate(restore) {
      const b = catalog.find(b => b.label === brand.value);
      model.replaceChildren(new Option(copy.chooseModel, ''));
      model.disabled = !b;
      b?.models.forEach(m => model.add(new Option(m.label.startsWith(b.label + ' ') ? m.label.slice(b.label.length + 1) : m.label, m.label)));
      if (restore && selected && selected.brand === b?.label) model.value = selected.label;
      update();
    }
    function update() {
      const bike = findBike(model.value);
      go.disabled = !bike;
      form.querySelector('[data-ry-note]').textContent = bike?.pending ? copy.pending : copy.note;
    }
    form.ryRefreshCatalog = () => {
      const oldBrand = brand.value, oldModel = model.value;
      brand.replaceChildren(new Option(copy.chooseBrand,''));
      catalog.forEach(b => brand.add(new Option(b.label,b.label)));
      brand.value = oldBrand; populate(false); model.value = oldModel; update();
    };
    populate(true);
    brand.addEventListener('change', () => populate(false));
    model.addEventListener('change', update);
    form.addEventListener('submit', e => {
      e.preventDefault();
      const bike = findBike(model.value);
      if (!bike) return;
      try { localStorage.setItem(storageKey, JSON.stringify({label:bike.label})); } catch {}
      track('ryvox_bike_selected', { bike_model:bike.label });
      if (isSearch) {
        const url = new URL(location.href);
        setScope(url.searchParams, bike.label); url.searchParams.set('ry_scope','bike'); url.searchParams.delete('page');
        location.assign(url.pathname + url.search);
      } else if (location.pathname.includes('/products/')) location.assign(location.pathname + location.search);
      else if (location.pathname.includes('/collections/')) {
        const url = new URL(location.href);
        setScope(url.searchParams, bike.label); url.searchParams.delete('page');
        location.assign(url.pathname + url.search);
      }
      else location.assign(modelUrl(bike));
    });
  });
  if (!catalogIsFresh) {
    (async () => {
      try {
        const response = await fetch(partsPath + '?section_id=ryvox-fitment-data', {signal:AbortSignal.timeout(3000)});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh = JSON.parse(html.querySelector('[data-ry-catalog-response]').textContent);
        if (!fresh.models?.length) return;
        models = buildModels(fresh.models); catalog = groupModels(models);
        forms.forEach(form => form.ryRefreshCatalog());
        try { sessionStorage.setItem(catalogCacheKey,JSON.stringify({models:fresh.models,time:Date.now()})); } catch {}
      } catch {}
    })();
  }
  function openFinder() {
    if (dialog?.showModal) { dialog.showModal(); dialog.querySelector('[data-ry-brand]')?.focus(); }
    else location.assign('/pages/parts-by-bike');
  }
  document.querySelectorAll('[data-ry-mobile-bike]').forEach(button => button.addEventListener('click', () => {
    button.closest('[data-drawer]')?.querySelector('[data-drawer-close]')?.click(); openFinder();
  }));
  document.querySelectorAll('[data-ry-open-bike]').forEach(button => button.addEventListener('click', openFinder));
  document.querySelectorAll('[data-ry-hero-find]').forEach(link => link.addEventListener('click', event => {
    if (window.matchMedia('(max-width: 749px)').matches) { event.preventDefault(); openFinder(); }
  }));
  document.querySelectorAll('[data-ry-hero-view]').forEach(button => button.addEventListener('click', () => {
    const hero = button.closest('[data-ry-hero]');
    const image = hero?.querySelector('[data-ry-hero-image]');
    if (!image || button.getAttribute('aria-pressed') === 'true') return;
    image.srcset = button.dataset.srcset; image.src = button.dataset.src;
    hero.querySelectorAll('[data-ry-hero-view]').forEach(view => view.setAttribute('aria-pressed',String(view === button)));
  }));

  const homeCompare = document.querySelector('[data-ry-home-compare]');
  if (homeCompare) {
    const toggles = [...homeCompare.querySelectorAll('[data-compare-toggle]')];
    const bar = homeCompare.querySelector('[data-ry-home-compare-bar]');
    const link = homeCompare.querySelector('[data-ry-home-compare-link]');
    const summary = homeCompare.querySelector('[data-ry-home-compare-summary]');
    const items = homeCompare.querySelector('[data-ry-home-compare-items]');
    let picked = [];
    const comparisonItem = toggle => ({handle:toggle.value,title:toggle.dataset.title || toggle.value,image:toggle.dataset.image || ''});
    try {
      const stored = JSON.parse(sessionStorage.getItem('ryvox-compare') || '[]');
      if (Array.isArray(stored)) picked = stored.map(item => toggles.find(toggle => toggle.value === item?.handle)).filter(Boolean).filter((toggle,index,list) => list.indexOf(toggle) === index).slice(0,2).map(comparisonItem);
    } catch {}
    function renderHomeCompare() {
      toggles.forEach(toggle => { const on = picked.some(item => item.handle === toggle.value); toggle.checked = on; toggle.disabled = picked.length === 2 && !on; });
      bar.hidden = !picked.length;
      summary.textContent = picked.length === 2 ? link.textContent.trim() + ' (2)' : copy.oneMore;
      if (items) {
        items.replaceChildren();
        picked.forEach(item => {
          const selectedBike = document.createElement('div');
          selectedBike.className = 'ag-compare-selection__bike';
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image; image.alt = ''; image.width = 56; image.height = 44;
            selectedBike.append(image);
          }
          const title = document.createElement('span');
          title.textContent = item.title;
          const remove = document.createElement('button');
          remove.type = 'button'; remove.dataset.ryCompareRemove = item.handle;
          remove.setAttribute('aria-label',bar.dataset.removeLabel + ' ' + item.title); remove.textContent = '×';
          selectedBike.append(title,remove); items.append(selectedBike);
        });
      }
      link.setAttribute('aria-disabled',String(picked.length !== 2));
      link.href = picked.length === 2 ? '/pages/compare?a=' + encodeURIComponent(picked[0].handle) + '&b=' + encodeURIComponent(picked[1].handle) : '/pages/compare';
      try { sessionStorage.setItem('ryvox-compare',JSON.stringify(picked)); } catch {}
    }
    toggles.forEach(toggle => toggle.addEventListener('change', () => {
      if (toggle.checked && picked.length < 2) picked.push(comparisonItem(toggle));
      else picked = picked.filter(item => item.handle !== toggle.value);
      renderHomeCompare();
    }));
    link.addEventListener('click',event => { if (picked.length !== 2) event.preventDefault(); });
    items?.addEventListener('click',event => {
      const remove = event.target.closest('[data-ry-compare-remove]');
      if (!remove) return;
      const handle = remove.dataset.ryCompareRemove;
      picked = picked.filter(item => item.handle !== handle); renderHomeCompare();
      toggles.find(toggle => toggle.value === handle)?.focus();
    });
    homeCompare.querySelector('[data-ry-home-compare-clear]')?.addEventListener('click', () => { picked = []; renderHomeCompare(); });
    renderHomeCompare();
  }
  document.querySelectorAll('[data-ry-close-bike]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog?.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
  document.querySelectorAll('[data-ry-clear-bike]').forEach(button => button.addEventListener('click', () => {
    try { localStorage.removeItem(storageKey); localStorage.removeItem('ryvox:selected-bike:v1'); } catch {}
    const url = new URL(location.href); url.searchParams.delete(param); url.searchParams.delete('page');
    if (isSearch) url.searchParams.set('ry_scope','all');
    location.assign(url.pathname + url.search);
  }));
  document.querySelectorAll('form[role="search"],form.search-sort').forEach(form => {
    const scope = form.querySelector('[data-ry-search-scope]');
    if (scope) {
      const bikeOption = scope.querySelector('[value="bike"]');
      scope.closest('.ry-search-scope').hidden = !selected;
      bikeOption.disabled = !selected;
      bikeOption.textContent = selected && !form.classList.contains('ry-header-search') ? copy.forBike.replace('{bike}',selected.label) : copy.bike;
      scope.title = selected ? copy.forBike.replace('{bike}',selected.label) : copy.bike;
      scope.value = selected ? initialScope : 'all';
    }
    let hiddenInputs = [...form.querySelectorAll(`input[name="${param}"]`)];
    const updateScope = () => {
      const useBike = selected && (scope ? scope.value === 'bike' : initialScope === 'bike');
      hiddenInputs.forEach(input => input.remove());
      hiddenInputs = (useBike ? scopeLabels(selected.label) : []).map(value => {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = param; input.value = value; form.append(input); return input;
      });
      form.querySelector('input[name="type"]')?.setAttribute('value','product');
    };
    updateScope();
    scope?.addEventListener('change', () => {
      updateScope();
      if (form.classList.contains('search-form') && !form.closest('.search-modal') && isSearch) {
        const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('ry_scope',scope.value);
        url.searchParams.delete(param); if (scope.value === 'bike' && selected) setScope(url.searchParams, selected.label);
        location.assign(url.pathname + url.search);
      }
    });
    form.addEventListener('submit', () => { updateScope(); track('ryvox_search_submitted',{bike_model:hiddenInputs.length?hiddenInputs[0].value:'',search_scope:hiddenInputs.length?'bike':'all'}); });
  });
  document.querySelectorAll('[data-ry-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  if (isSearch) {
    const showAll = document.querySelector('[data-ry-search-all]');
    if (showAll) { const u = new URL(location.href); u.searchParams.delete(param); u.searchParams.delete('page'); u.searchParams.set('ry_scope','all'); showAll.href = u.pathname + u.search; }
  }
  if (selected) {
    document.querySelectorAll('[data-ry-bike-label]').forEach(node => {
      const button = node.closest('.ry-my-bike');
      node.textContent = button ? button.getAttribute('aria-label') : selected.label;
      if (button) { button.title = selected.label; button.setAttribute('aria-label', selected.label); }
    });
    const status = document.querySelector('[data-ry-bike-status]');
    if (status) {
      status.hidden = false;
      status.querySelector('[data-ry-scope]').textContent = urlBike && isSelectedValue(urlBike) ? copy.scope : copy.saved;
      status.querySelector('[data-ry-view-parts]').href = modelUrl(selected);
    }
  }
  function fitmentMessages(root = document) {
    root.querySelectorAll('[data-ry-fitment]').forEach(node => {
      if (node.closest('[data-ry-bike-related]') || !selected || node.dataset.ryFitDone === selected.label) return;
      node.dataset.ryFitDone = selected.label;
      let listed = []; try { listed = JSON.parse(node.dataset.models) || []; } catch {}
      const inScope = scopeLabels(selected.label);
      const listedAs = listed.includes(selected.label) ? selected.label : listed.find(value => value !== UNIVERSAL && inScope.includes(value));
      const universal = !listedAs && listed.includes(UNIVERSAL);
      const match = !!listedAs || universal;
      const state = match ? 'listed' : listed.length ? 'different' : 'unknown';
      node.dataset.state = state; node.hidden = false;
      node.querySelector('[data-ry-fit-title]').textContent = match
        ? (universal ? (copy.universal || 'Check fitment · Universal fit') : copy.listed.replace('{bike}', listedAs))
        : (state === 'different' ? copy.notListed : copy.unconfirmed).replace('{bike}',selected.label);
      node.querySelector('[data-ry-fit-body]').textContent = node.hasAttribute('data-detail') ? (match ? copy.variantNote : copy.askFitment) : '';
      const card = node.closest('.card');
      if (!match && card) card.querySelector('[data-quick-add]')?.setAttribute('hidden','');
    });
  }
  let categoryRoutes = [];
  try { categoryRoutes = JSON.parse(document.getElementById('ry-category-catalog')?.textContent || '[]'); } catch {}
  function scopeLinks(root = document) {
    const handles = new Set(['performance-parts','wheels','tires','brakes','suspension','drivetrain','controls','controllers','motors','batteries-chargers','protection','lighting-electrical','accessories','supermoto']);
    root.querySelectorAll('a[href]').forEach(link => {
      if (link.dataset.ryScoped || link.matches('[data-ry-remove-bike],[data-ry-browse-all]') || link.closest('[data-ry-search-all]')) return;
      const u = new URL(link.getAttribute('href'),location.origin);
      if (u.origin !== location.origin) return;
      const handle = u.pathname.split('/collections/')[1];
      if (!handles.has(handle)) return;
      const category = categoryRoutes.find(route => route.handle === handle);
      if (category && !link.hasAttribute('data-facet-link') && !link.hasAttribute('data-ry-direct')) {
        const target = new URL(category.url, location.origin);
        [...new Set([...u.searchParams.keys()])].filter(key => key.startsWith('filter.') || key === 'sort_by').forEach(key => {
          target.searchParams.delete(key); u.searchParams.getAll(key).forEach(value => target.searchParams.append(key,value));
        });
        u.pathname = target.pathname; u.search = target.search;
      }
      if (selected && !link.closest('footer,.footer') && !link.hasAttribute('data-facet-link')) {
        if (link.closest('.catalog-nav') && urlBike && !isSelectedValue(urlBike)) return;
        setScope(u.searchParams, selected.label);
      }
      link.href = u.pathname + u.search; link.dataset.ryScoped = 'true';
    });
  }
  function contactLinks(root = document) {
    root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (url.origin !== location.origin || url.pathname !== '/pages/contact' || url.searchParams.has('service')) return;
      if (selected && !url.searchParams.has('bike')) url.searchParams.set('bike', selected.label);
      if (location.pathname.includes('/products/')) {
        const title = document.querySelector('h1');
        if (title && !url.searchParams.has('product')) url.searchParams.set('product', title.textContent.trim());
      }
      link.href = url.pathname + url.search;
    });
  }
  contactLinks();
  function productForms(root = document) {
    if (!selected) return;
    root.querySelectorAll('form[data-product-form],form[data-quick-add]').forEach(form => {
      if (form.hasAttribute('data-ry-complete-bike') || form.querySelector('[data-ry-line-bike],[data-ry-wheel-model]')) return;
      if (!form.closest('.pdp__info') && !form.closest('.card')) return;
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[Selected bike]'; input.value = selected.label; input.dataset.ryLineBike = 'true'; form.append(input);
    });
    root.querySelectorAll('[data-ry-cart-attribute]').forEach(input => { input.disabled = false; input.value = selected.label; });
    root.querySelectorAll('[data-ry-cart-current]').forEach(node => { node.textContent = selected.label; });
    root.querySelectorAll('[data-ry-cart-bike]').forEach(node => { node.hidden = false; });
  }
  document.addEventListener('click', e => {
    const remove = e.target.closest('[data-ry-remove-bike],[data-ry-browse-all]');
    if (!remove) return;
    e.preventDefault(); e.stopImmediatePropagation();
    try { localStorage.removeItem(storageKey); localStorage.removeItem('ryvox:selected-bike:v1'); } catch {}
    location.assign(remove.href);
  },true);
  if (selected && urlBike && isSelectedValue(urlBike)) {
    const collectionHeading = document.querySelector('.collection-head__title');
    if (collectionHeading && !collectionHeading.textContent.includes(selected.label)) collectionHeading.textContent = selected.label + ' · ' + collectionHeading.textContent.trim();
  }
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    const groups = [...form.querySelectorAll('[data-ry-model-option]')].filter(group => group.querySelectorAll('input[type="radio"]').length > 1);
    if (!groups.length) return;
    const note = document.createElement('p'); note.className = 'ry-option-note'; note.textContent = copy.chooseOption;
    form.prepend(note);
    const paymentButtons = form.querySelector('.shopify-payment-button');
    if (paymentButtons) paymentButtons.hidden = true;
    const confirmed = new Set();
    groups.forEach(group => group.addEventListener('click', e => {
      if (!e.target.closest('input,label,select,option')) return;
      confirmed.add(group);
      if (confirmed.size === groups.length) { note.hidden = true; if (paymentButtons) paymentButtons.hidden = false; }
    }));
    groups.forEach(group => group.addEventListener('change', () => { confirmed.add(group); if (confirmed.size === groups.length) { note.hidden = true; if (paymentButtons) paymentButtons.hidden = false; } }));
    form.addEventListener('submit', e => {
      if (confirmed.size === groups.length) return;
      e.preventDefault(); e.stopImmediatePropagation(); note.hidden = false;
      const target = groups.find(group => !confirmed.has(group)); target?.scrollIntoView({block:'center',behavior:'smooth'}); target?.querySelector('input:not(:disabled),select')?.focus();
    },true);
  });
  const recommendationHost = document.querySelector('[data-recommendations]');
  if (selected && recommendationHost) {
    const fallback = document.querySelector('[data-rec-fallback]');
    if (fallback) fallback.hidden = true;
    const recommendationUrl = new URL('/search',location.origin);
    recommendationUrl.searchParams.set('q','*'); recommendationUrl.searchParams.set('type','product');
    setScope(recommendationUrl.searchParams, selected.label); recommendationUrl.searchParams.set('section_id','ryvox-model-picks');
    fetch(recommendationUrl.pathname + recommendationUrl.search,{signal:AbortSignal.timeout(5000)}).then(r => r.ok ? r.text() : '').then(html => {
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const section = parsed.querySelector('[data-ry-model-results]');
      if (!section) return;
      section.querySelectorAll('.card').forEach(card => { const href = card.querySelector('a[href]')?.getAttribute('href'); if (href && new URL(href,location.origin).pathname === location.pathname) card.remove(); });
      if (!section.querySelector('.card')) return;
      section.querySelectorAll('[data-quick-add]').forEach(form => form.remove());
      section.querySelectorAll('.reveal').forEach(card => card.classList.add('is-in'));
      recommendationHost.replaceChildren(section);
      fitmentMessages(recommendationHost);
    }).catch(() => {});
  }
  fitmentMessages(); scopeLinks(); productForms();
  let scheduled = false;
  new MutationObserver(records => {
    const relevant = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-ry-fitment],.product-grid,[data-cart-items]') || node.querySelector('[data-ry-fitment],.product-grid,[data-cart-items]'))));
    if (!relevant || scheduled) return;
    scheduled = true; requestAnimationFrame(() => { scheduled = false; fitmentMessages(); scopeLinks(); productForms(); });
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('click',e => { const link = e.target.closest('a[data-ry-journey]'); if (link) track('ryvox_journey_selected',{journey:link.dataset.ryJourney}); });
})();
